export const CLOSE = 'Close'
export const COPY_SUCCESS_INTERSTITIAL_MODAL_ID = 'copy-success-interstital-modal'
export const AD_ID = 'D_MISC-COPY'
export const AD_CONTAINER_TEST_ID = 'ad-container-test-id'
export const CLOSE_BAR_TEST_ID = 'close-bar-test-id'
